import { Component } from '@angular/core';
import { DialogContent } from '@shared/components/dialog/dialog.component';
import { TranslateService } from '@ngx-translate/core';

import { Tag } from '../models/tag.model';

export interface DeleteTagDialogContentData {
    tag: Tag,
    workflows: { id: number, name: string }[];
    savedFilters: { id: number, name: string }[];
    reports: { id: number, title: string }[];
}

@Component({
    selector: 'sfx-manage-tags-delete-tag-content',
    template: `
        <p translate>
            Are you sure you want to delete this tag?
        </p>
        <p [innerHTML]="message">
            {{ message }}
        </p>
    `,
    styles: ['p { max-width: 500px; }']
})
export class DeleteTagDialogContentComponent implements DialogContent<DeleteTagDialogContentData> {

    context: DeleteTagDialogContentData;

    message: string;

    constructor(
        private translate: TranslateService
    ) {}

    private _constructEntityMessage(entity: string, names: string[]): string {

        const amount = names.length;
        const namesString = names.join(', ');
        const entityKey = amount > 1 ? entity + 's' : entity;
        const entityText = this.translate.instant(entityKey);
        const prefix = amount > 1 ? amount.toString() : this.translate.instant('a');

        return this.translate.instant('{{prefix}} {{entity}} ({{names}})', {
            prefix,
            entity: entityText,
            names: namesString
        });
    }

    setInitialState(context: DeleteTagDialogContentData): void {

        this.context = context;

        const usages = [];

        const filtersAmount = this.context.savedFilters.length;
        const workflowsAmount = this.context.workflows.length;
        const reportsAmount = this.context.reports.length;

        if (workflowsAmount > 0) {

            usages.push(this._constructEntityMessage('workflow', this.context.workflows.map((workflow) => workflow.name)));
        }

        if (filtersAmount > 0) {

            usages.push(this._constructEntityMessage('filter', this.context.savedFilters.map((filter) => filter.name)));
        }

        if (reportsAmount > 0) {

            usages.push(this._constructEntityMessage('report', this.context.reports.map((report) => report.title)));
        }

        if (usages.length > 0) {
            const usagesText = usages.length > 2
                ? `${usages.slice(0, -1).join(', ')} ${this.translate.instant('and')} ${usages.slice(-1)}`
                : usages.join(` ${this.translate.instant('and')} `);
            this.message = this.translate.instant('Note that this tag is used in {{usages}}.', { usages: usagesText });
        }
    }

    getCurrentState(): DeleteTagDialogContentData {

        return this.context;
    }

    public valid: true;
}
